import { render, staticRenderFns } from "./reviewCompanyResult.vue?vue&type=template&id=76175050"
import script from "./reviewCompanyResult.vue?vue&type=script&lang=js"
export * from "./reviewCompanyResult.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports